import KeySpeakers from "../components/Speakers/KeySpeakers";
import PreConference from "../components/Speakers/PreConference";
import Footer from '../components/Footer'
export default function Speakers() {
    return(
        <main className=" mt-28">
            {/* <p className=" pt-20 text-2xl text-red-500 font-bold text-center">Speakers will be announced soon</p>   */}
            <KeySpeakers />
            <PreConference />
            <Footer />
        </main>
    )
}